module.exports = __webpack_public_path__ + "static/media/29DUNON15.d0f400f0.jpg";